<template>
    <detail :id="id" verify></detail>
</template>

<script>
    import detail from './special_price_detail.vue'

    export default {
        name: 'special_price_verify',

        components: {
            detail
        },

        props: {
            id: String
        }
    }
</script>